export default __webpack_public_path__ + "37268211a2cf2df6a53741ba28f57701.png";